export default __webpack_public_path__ + "static/base-map-3a4507dd0cd663c6a1e193c10ee354c4.svg";